import router from '../router'
import Icon from "ant-design-vue/es/icon";
import Vue from "vue"

function updateUserInfo(userInfo, userToken) {
    sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
    sessionStorage.setItem('userToken', userToken)
}

function getUserInfo() {
    let item = sessionStorage.getItem('userInfo');
    if (item) {
        return JSON.parse(item)
    }
    Vue.prototype.$notification.open({
        message: '未登录！禁止操作！',
        description:
            '即将跳转登录页面……',
        icon: (h) => {
            return h(Icon, {
                attrs: {type: 'close-circle', style: 'color: red'}
            });
        }
    });
    setTimeout(()=>{
        router.push("/login")
    }, 2800)
}

export {
    getUserInfo,
    updateUserInfo
};
